import { useContext, useState } from "react"
import getCursos from "../services/getCursos"
import { AuthContext } from "../contexts/auth"
import deleteCurso from "../services/deleteCurso"
import toast from "react-hot-toast"

const useCursosState = () => {

    

    const { signOut } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [cursoDeletar, setCursoDeletar] = useState(false)
    const [pesquisa, setPesquisa] = useState('')
    const [cursos, setCursos] = useState([])
    const [submit, setSubmit] = useState(false)
    
    const [ openPermissaoDialog, setOpenPermissaoDialog ] = useState(false)

    const _getCursos = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getCursos('admin/cursos/', pesquisa === '' ? null: pesquisa)
        if (result.type === 'success'){
            
            setCursos(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _deleteCurso = async ()=>{
        if (submit){
            return;
        }
        setOpenDialog(false)
        setSubmit(true)
        let result = await deleteCurso(`admin/cursos/${cursoDeletar.id}/`)
        if (result.type === 'success'){
            
            toast.success(result.data.detail)
            _getCursos()
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }

        setSubmit(false)
    } 

    return {
        
        cursos: {value: cursos, set:_getCursos},
        pesquisa: {value: pesquisa, set:setPesquisa},
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: _deleteCurso},
        itemDelete:{value:cursoDeletar, set:setCursoDeletar},  
        submit: {value: submit, set: _getCursos},
        openPermissaoDialog: {value: openPermissaoDialog, set: setOpenPermissaoDialog},
    }
}

export default useCursosState